// First-touch attribution for the funnel (R4). A video description links to
// /start?utm_source=youtube&utm_campaign=…; we keep the first UTM-bearing (or
// funnel-entry) visit in localStorage and hand it to /api/auth/register as
// `source`, so sign-ups from a video can be counted. Nothing here is shown to
// the person, nothing identifies them, and storage can fail (private window,
// blocked site data) without anything breaking.

const KEY = 'veg_first_touch';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const FUNNEL_PATHS = ['/start', '/quiz'];
const MAX = 255;

export const captureFirstTouch = (search, pathname) => {
  try {
    if (localStorage.getItem(KEY)) return;
    const params = new URLSearchParams(search || '');
    const parts = UTM_KEYS
      .filter((k) => params.get(k))
      .map((k) => `${k}=${encodeURIComponent(params.get(k).slice(0, 60))}`);
    if (parts.length === 0 && !FUNNEL_PATHS.includes(pathname)) return;
    parts.push(`landing=${pathname}`);
    localStorage.setItem(KEY, parts.join('&').slice(0, MAX));
  } catch {
    /* storage unavailable — attribution is a nicety */
  }
};

export const signupSource = () => {
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
};

// Carry the current query string (UTMs) onto an internal link so a visitor who
// bounces landing → /start → /register keeps their attribution on the URL too.
export const withSearch = (path, search) => {
  const q = (search || '').replace(/^\?/, '');
  if (!q) return path;
  return `${path}${path.includes('?') ? '&' : '?'}${q}`;
};
